import React, { useContext } from "react";
import ShopButton from "../../elements/ShopButton";
// Replace with the correct ModalContext import
import { useModal } from "../../context/ModalContext";
import { logAnalyticsEvent } from "../../firebase/firebaseConfig";
import { EnvContext } from "../../context/EnvContext";

const LoginComponent = ({ toggleMenu }) => {
  const { setCurrentModal } = useModal(); // Use the ModalContext hook
  const environment = useContext(EnvContext);

  return (
    <div>
      <ShopButton
        text="Sign Up"
        theme="dark"
        onClick={() => {
          // analytics
          logAnalyticsEvent("menu_click", {
            item: "Sign up",
            environment: environment,
          });
          // close menue drawer
          setCurrentModal("signUp"); // Open the Sign Up modal
          toggleMenu();
        }}
      />
      <div style={{ fontWeight: "500", padding: "2px 0", fontSize: "1rem", textAlign: "center" }}>or</div>
      <ShopButton
        text="Sign In"
        theme="light"
        outlined
        onClick={() => {
          // analytics
          logAnalyticsEvent("menu_click", {
            item: "Sign in",
            environment: environment,
          });
          setCurrentModal("signIn"); // Open the Sign In modal
          toggleMenu();
        }}
      />
    </div>
  );
};

export default LoginComponent;
